import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/headphones-start-test',
    name: 'headphones-start-test',
    component: () => import(/* webpackChunkName: "headphones-start-test" */ '../views/headphones-start-test')
  },
  {
    path: '/hearing-loss-classification-results',
    name: 'hearing-loss-classification-results',
    component: () => import(/* webpackChunkName: "hearing-loss-classification-results" */ '../views/hearing-loss-classification-results')
  },
  {
    path: '/hearing-loss-results',
    name: 'hearing-loss-results',
    component: () => import(/* webpackChunkName: "hearing-loss-results" */ '../views/hearing-loss-results')
  },
  {
    path: '/load-previous',
    name: 'load-previous',
    component: () => import(/* webpackChunkName: "load-previous" */ '../views/load-previous')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login')
  },
  {
    path: '/phonems-audiogram-results',
    name: 'phonems-audiogram-results',
    component: () => import(/* webpackChunkName: "phonems-audiogram-results" */ '../views/phonems-audiogram-results')
  },
  {
    path: '/save-to-database',
    name: 'save-to-database',
    component: () => import(/* webpackChunkName: "save-to-database" */ '../views/save-to-database')
  },
  {
    path: '/select-age',
    name: 'select-age',
    component: () => import(/* webpackChunkName: "select-age" */ '../views/select-age')
  },
  {
    path: '/select-gender',
    name: 'select-gender',
    component: () => import(/* webpackChunkName: "select-gender" */ '../views/select-gender')
  },
  {
    path: '/select-source',
    name: 'select-source',
    component: () => import(/* webpackChunkName: "select-source" */ '../views/select-source')
  },
  {
    path: '/set-volume',
    name: 'set-volume',
    component: () => import(/* webpackChunkName: "set-volume" */ '../views/set-volume')
  },
  {
    path: '/speaker-start-test',
    name: 'speaker-start-test',
    component: () => import(/* webpackChunkName: "speaker-start-test" */ '../views/speaker-start-test')
  },
  {
    path: '/',
    name: 'start',
    component: () => import(/* webpackChunkName: "start" */ '../views/start')
  },
  {
    path: '/successful',
    name: 'successful',
    component: () => import(/* webpackChunkName: "successful" */ '../views/successful')
  },
  {
    path: '/test-headset',
    name: 'test-headset',
    component: () => import(/* webpackChunkName: "test-headset" */ '../views/test-headset')
  },
  {
    path: '/test-speakers',
    name: 'test-speakers',
    component: () => import(/* webpackChunkName: "test-speakers" */ '../views/test-speakers')
  },
  {
    path: '/who-classification-criteria',
    name: 'who-classification-criteria',
    component: () => import(/* webpackChunkName: "who-classification-criteria" */ '../views/who-classification-criteria')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
